export const BID_SPREAD_ANALYSIS_EARLIEST_DATE = new Date(2022, 0, 1)

export type BidSpreadAnalysisPeriod = 'last30' | 'last60' | 'last90' | 'last120' | 'custom'

export const BID_SPREAD_ANALYSIS_TIME_PERIODS: { value: BidSpreadAnalysisPeriod; label: string }[] =
  [
    { value: 'last30', label: 'Last 30 days' },
    { value: 'last60', label: 'Last 60 days' },
    { value: 'last90', label: 'Last 90 days' },
    { value: 'last120', label: 'Last 120 days' },
    { value: 'custom', label: 'Custom' },
  ]

const PERIOD_SLUGS: Record<Exclude<BidSpreadAnalysisPeriod, 'custom'>, string> = {
  last30: 'last30days',
  last60: 'last60days',
  last90: 'last90days',
  last120: 'last120days',
}

export const resolveBidSpreadAnalysisPeriodSlug = (
  period: BidSpreadAnalysisPeriod,
  start: Date | null,
  end: Date | null,
): string => {
  if (period !== 'custom') return PERIOD_SLUGS[period]
  const format = (date: Date | null) =>
    date
      ? `${date.getFullYear()}${String(date.getMonth() + 1).padStart(2, '0')}${String(
          date.getDate(),
        ).padStart(2, '0')}`
      : 'unknown'
  return `custom_${format(start)}_${format(end)}`
}

export type BidSpreadAnalysisView = 'absolute' | 'percentage'
export const BID_SPREAD_ANALYSIS_VIEWS: { value: BidSpreadAnalysisView; label: string }[] = [
  { value: 'absolute', label: '£ Absolute' },
  { value: 'percentage', label: '% Percentage' },
]

export type BidSpreadAnalysisJobValueFilter =
  | 'all'
  | 'under50'
  | '50to200'
  | '200to500'
  | 'over500'
  | 'custom'
export const BID_SPREAD_ANALYSIS_JOB_VALUE_FILTERS: {
  value: BidSpreadAnalysisJobValueFilter
  label: string
}[] = [
  { value: 'all', label: 'All job values' },
  { value: 'under50', label: 'Under £50' },
  { value: '50to200', label: '£50 - £200' },
  { value: '200to500', label: '£200 - £500' },
  { value: 'over500', label: '£500+' },
  { value: 'custom', label: 'Custom' },
]

const JOB_VALUE_RANGES: Record<
  Exclude<BidSpreadAnalysisJobValueFilter, 'custom'>,
  { min: number | null; max: number | null }
> = {
  all: { min: null, max: null },
  under50: { min: null, max: 50 },
  '50to200': { min: 50, max: 200 },
  '200to500': { min: 200, max: 500 },
  over500: { min: 500, max: null },
}

export const resolveBidSpreadAnalysisJobValueRange = (
  filter: BidSpreadAnalysisJobValueFilter,
  customMin: number | null,
  customMax: number | null,
): { min: number | null; max: number | null } =>
  filter === 'custom' ? { min: customMin, max: customMax } : JOB_VALUE_RANGES[filter]
export const BID_SPREAD_ANALYSIS_CHART_HEIGHT = 340
